export const TRANSLATIONS_EN_SETTINGS_GOOGLE = {
  "settings.google.connection_status_title": "Connection status",
  "settings.google.loading_status": "Loading status...",
  "settings.google.connected": "Connected",
  "settings.google.connect_button": "Connect with Google",
  "settings.google.no_accounts": "No accounts connected.",
  "settings.google.gmail_messages_title": "Gmail messages",
  "settings.google.no_messages": "No messages to display.",
  "settings.google.drive_files_title": "Drive files",
  "settings.google.root": "(Root)",
  "settings.google.no_files": "No files to display.",
  "settings.google.diagnostics_title": "Diagnostics and tests",
  "settings.google.audit_title": "Audit and security",
  "settings.google.manage_access_link": "Manage access in my Google Account",
  "settings.google.privacy_policy": "Privacy policy",
  "settings.google.terms_of_service": "Terms of service",
  "settings.google.multi_account_title": "Multi‑account management",
  "settings.google.reauthorize": "Reauthorize",
  "settings.google.revoke": "Revoke",
  "settings.google.make_default": "Make default",
  "settings.google.oauth_processing": "Processing Google authentication...",
  "settings.google.table.subject": "Subject",
  "settings.google.table.from": "From",
  "settings.google.table.received_at": "Received",
  "settings.google.table.body_preview": "Preview",
  "settings.google.table.has_attachments": "Attachments",
  "settings.google.table.name": "Name",
  "settings.google.table.type": "Type",
  "settings.google.table.size": "Size",
  "settings.google.table.modified": "Modified",
  "settings.google.table.created_by": "Created by",
  "settings.google.table.status": "Status",
  "settings.google.table.time": "Time",
  "settings.google.table.message": "Message",
  "settings.google.table.account": "Account",
  "settings.google.table.scopes": "Scopes",
  "settings.google.table.default": "Default",
  "settings.google.table.actions": "Actions",
  "settings.google.table.sync_period": "Sync from",
  "settings.google.save_sync_start_date": "Save date",
  'settings.google.sync_process_title': 'Account Synchronization',
  'settings.google.sync.mail_sync_status': 'Mail sync status',
  'settings.google.sync.drive_sync_status': 'Drive sync status',
  'settings.google.sync.last_read_email_date': 'Last synchronized email date',
  'settings.google.sync.last_sync_date': 'Last sync date',
  'settings.google.sync.emails_processed': 'Emails processed',
  'settings.google.sync.period': 'Sync period',
  'settings.google.sync.period_updated_prefix': 'Synchronization start date updated to',
  'settings.google.sync.resync_requested': 'Re-sync requested.',
  'settings.google.sync.set_period': 'Set period',
  'settings.google.sync.all': 'All',
  'settings.google.sync.not_set': 'Not set',
};
